/**
 * 경량 i18n. 접속자 브라우저 언어(navigator.language)로 로케일 자동 선택.
 * ko/ja/zh를 접두사로 감지하고, 그 외에는 영어(en)로 폴백. t(key, params)로 문자열을 얻는다.
 */
import { STRINGS, type Locale } from './locales';

function detectLocale(): Locale {
  const lang = (typeof navigator !== 'undefined' && navigator.language) || 'en';
  const l = lang.toLowerCase();
  if (l.startsWith('ko')) return 'ko';
  if (l.startsWith('ja')) return 'ja';
  if (l.startsWith('zh')) return 'zh'; // 간체/번체 모두 zh(간체)로 우선 매핑
  return 'en';
}

/** 현재 로케일(모듈 로드 시 1회 결정). */
export const LOCALE: Locale = detectLocale();

type Params = Record<string, string | number>;

/** 키로 현재 로케일 문자열을 얻는다. {name} 자리표시자는 params로 치환. */
export function t(key: string, params?: Params): string {
  let s = STRINGS[LOCALE][key] ?? STRINGS.en[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      s = s.split(`{${k}}`).join(String(v));
    }
  }
  return s;
}
